import NavBar from '../components/NavBar/navBar';
import Footer from '../components/Footer/footer';
import Banner from '../components/Banner/banner';
import LocationContent from '../components/PageContent/LocationContent/locationContent';

function Home() {
  return (
    <div className="app app-home">
      <NavBar pageActive={1}/>
      <div className="page-content">
        <Banner />
        <div className="page-content-map">
          <LocationContent />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
